import { createRouter, createWebHistory } from "vue-router";
import Vue from "vue";

import VueRouter from "vue-router";

import Dashboard from "./pages/Dashboard.vue";
import UsersList from "./pages/UsersList.vue";
export const routeHistoryData = [];
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "",
      component: () => import("./layouts/Main.vue"),
      children: [
        { path: "/", component: Dashboard },
        { path: "/users", component: UsersList },
        {
          path: "/invoice",
          name: "invoice",
          component: () => import("@/pages/invoice/index.vue")
        },
        {
          path: "/viewInvoice/:id",
          name: "viewInvoice",
          component: () => import("@/pages/invoice/viewInvoice.vue")
        },
        {
          path: "/topup",
          name: "topup",
          component: () => import("@/pages/topup/index.vue")
        },
        {
          path: "/manage-service",
          name: "manage-service",
          component: () => import("@/pages/manage-service/index.vue")
        },
        {
          path: "/createManageService",
          name: "createManageService",
          component: () =>
            import("@/pages/manage-service/createManageService.vue")
        },
        {
          path: "/payments",
          name: "payments",
          component: () => import("@/pages/payments/paymentList.vue")
        },
        {
          path: "/transactions",
          name: "transactions",
          component: () => import("@/pages/transactions/transactionList.vue")
        },
        {
          path: "/paperless",
          name: "paperless",
          component: () => import("@/pages/paperless/paperlessList.vue")
        },
        {
          path: "/help",
          name: "help",
          component: () => import("@/pages/help/index.vue")
        },
        {
          path: "/createHelp",
          name: "createHelp",
          component: () => import("@/pages/help/createHelp.vue")
        },
        {
          path: "/profileSetting",
          name: "profileSetting",
          component: () => import("@/pages/profileSetting/index.vue")
        },
        {
          path: "/changePassword",
          name: "changePassword",
          component: () => import("@/pages/profileSetting/changePassword.vue")
        },
        {
          path: "/editProfile",
          name: "editProfile",
          component: () => import("@/pages/profileSetting/editProfile.vue")
        }
      ]
    },

    {
      path: "",
      component: () => import("@/layouts/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/pages/Login.vue")
        },
        {
          path: "/error-404",
          name: "page-error-404",
          component: () => import("@/pages/Error404.vue")
        },
        {
          path: "*",
          name: "page-error-404",
          component: () => import("@/pages/Error404.vue")
        }
      ]
    }
  ]
});

export default router;
